export const tagsAlocacao = {
  titulo: 'Allocation tags',
  descricao: 'The tags managers assign to allocations.',
  nova: 'New tag',
  total_one: 'Showing {{showing}} of {{count}} tag',
  total_other: 'Showing {{showing}} of {{count}} tags',
  colunas: {
    nome: 'Name',
    cor: 'Color',
    ativa: 'Active',
    alocacoes: 'Linked allocations',
  },
  filtros: {
    avancadosDescricao:
      'The fields follow the visible table columns: show or hide columns in "Columns" to change the available filters.',
    corPlaceholder: 'E.g. #00BCD4',
  },
  tabela: {
    acoesDaTag: 'Actions for tag {{nome}}',
    vazioTitulo: 'No tags yet',
    vazioDescricao: 'Create the first one so managers can label allocations.',
    filtroSemResultadoTitulo: 'No tags match these filters',
    filtroSemResultadoDescricao: 'Adjust or clear the filters to see the tags.',
  },
  acoes: {
    editar: 'Edit',
    excluir: 'Delete',
  },
  form: {
    tituloNova: 'New allocation tag',
    tituloEditar: 'Edit allocation tag',
    nome: 'Name',
    cor: 'Color',
    corSeletor: 'Pick the color',
    corDica: 'Hexadecimal, e.g. #00BCD4.',
    ativa: 'Active',
    ativaDica:
      'An inactive tag is not offered for new allocations or in the filters, but stays on the allocations that already have it.',
    previa: 'Preview',
    emUso_one: 'Linked to {{count}} allocation.',
    emUso_other: 'Linked to {{count}} allocations.',
    criar: 'Create tag',
  },
  validacao: {
    nomeMaximo: 'Use up to {{max}} characters.',
    corInvalida: 'Use the #RRGGBB format.',
  },
  excluir: {
    titulo: 'Delete the tag "{{nome}}"?',
    descricao:
      'No allocation uses this tag, so it will be deleted for good. This cannot be undone.',
    emUso:
      'This tag is linked to allocations and cannot be deleted. To retire it, edit it and turn it inactive.',
    confirmar: 'Delete tag',
  },
  toasts: {
    criarSucesso: 'Tag created.',
    atualizarSucesso: 'Tag updated.',
    excluirSucesso: 'Tag deleted.',
  },
  exportacao: {
    titulo: 'Export tags',
    todasPaginas_one: 'All pages ({{count}} tag)',
    todasPaginas_other: 'All pages ({{count}} tags)',
    paginaAtual_one: 'This page only ({{count}} tag)',
    paginaAtual_other: 'This page only ({{count}} tags)',
    nomeArquivo: 'allocation-tags',
  },
} as const;
